// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { addTagsModalStyles } from "@insite/content-library/Widgets/MyListsDetails/AddTagsModal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addTagsModalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        gap: 10px;
    `,
};
addTagsModalStyles.cancelButton = {
    variant: "secondary",
};
addTagsModalStyles.tagText = {
    css: css`
        display: flex;
        background: ${getColor("primary.main")};
        color: ${getColor("primary.contrast")};
        &:hover {
            background: #1b3f76;
        }
        border-radius: 4px;
        white-space: nowrap;
        margin-right: 6px;
        margin-bottom: 6px;
        padding: 2px 6px;
        font-size: 15px;
        align-items: center;
        text-wrap: wrap;
    `,
};
addTagsModalStyles.tagInputText = {};

addTagsModalStyles.fakeTextFieldStyle = {
    css: css`
        border: none;
        margin-top: 0;
        padding: 0;
        row-gap: 10px;
    `,
};
